import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import PWDKButton from 'components/new/PWDKButton';
import { AutoAwesome } from '@mui/icons-material';

const AlumniVerification = ({ alumniData, onMenuClick }) => {
  return (
    <Box mx={1} padding="8px" borderRadius="8px" bgcolor="neutral800.main">
      <Stack alignItems="center" spacing={{ xs: 2, md: 1 }}>
        <Stack alignItems="center" spacing={{ xs: 0.5, md: 1 }}>
          <AutoAwesome
            sx={{
              transform: 'scaleX(-1)',
              fontSize: { xs: '20px', md: '24px' },
              color: 'primaryBrandPurwadhika.main',
            }}
          />

          <Typography
            variant="captionreguler"
            color="neutral300.main"
            textAlign="center"
          >
            Unlock this feature once you become an alumni.
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default AlumniVerification;
